<template>
  <transition name="slide">
    <div v-if="isVisible" class="notification has-background-danger">
      <div class="level has-text-white">
        <div class="level-left">
          <div class="level-item">
            <slot/>
          </div>
        </div>
        <div class="level-right" @click="dismiss">
          <b-icon icon="close" size="is-small" @click="dismiss"/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isVisible: this.visible
    }
  },
  watch: {
    visible (value) {
      this.isVisible = value
    }
  },
  methods: {
    dismiss () {
      this.isVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  margin: 0.5em 0.5em 0 0.5em;
  height: 60px;
  flex: none !important;
}
</style>
